import type { PrepareAllCommentsOptionsReturnType } from './prepareAllCommentsOptions';

interface PrepareNewParamsArgs {
  selects?: PrepareAllCommentsOptionsReturnType['selects'];
  checkboxes?: PrepareAllCommentsOptionsReturnType['checkboxes'];
  orderChange?: PrepareAllCommentsOptionsReturnType['orderChange'];
  orderHome?: PrepareAllCommentsOptionsReturnType['orderHome'];
  type: string;
  value: string | boolean | number;
  index: number;
}

type PrepareNewParamsReturnType = Omit<
  PrepareNewParamsArgs,
  'type' | 'value' | 'index'
>;

const prepareNewParams = ({
  selects,
  checkboxes,
  orderChange,
  orderHome,
  type,
  value,
  index
}: PrepareNewParamsArgs): PrepareNewParamsReturnType => {
  let newState: PrepareNewParamsReturnType = {};

  if (type === 'orderChange') {
    newState = {
      orderChange: {
        ...orderChange,
        value: value as string
      }
    };
  } else if (type === 'orderHome') {
    newState = {
      orderHome: {
        ...orderHome,
        value: value as boolean
      }
    };
  } else if (type === 'checkboxes') {
    if (!checkboxes?.length) {
      return newState;
    }
    newState = {
      checkboxes: [
        ...checkboxes.slice(0, index),
        {
          ...checkboxes[index],
          value: value as boolean
        },
        ...checkboxes.slice(index + 1)
      ]
    };
  } else if (type === 'selects') {
    if (!selects?.length) {
      return newState;
    }
    newState = {
      selects: [
        ...selects.slice(0, index),
        {
          ...selects[index],
          value: value as number
        },
        ...selects.slice(index + 1)
      ]
    };
  }
  return newState;
};

export default prepareNewParams;
